import React from 'react'

import { Box, Checkbox, FormControlLabel, Typography } from '@material-ui/core'
import { isEmpty } from 'lodash'

import useStyles from './styles'

const RiskOptionsSelector = ({ options = [], value = [], onChange }) => {
  const classes = useStyles()

  const handleChange = (optionId, checked) => {
    if (checked) {
      onChange([...value, optionId])
    } else {
      onChange(value.filter((id) => id !== optionId))
    }
  }

  if (isEmpty(options)) return null

  return (
    <Box>
      {options.map((parent) => (
        <Box key={parent.id} mb={1}>
          <Typography variant="body2" className={classes.sectionTitle}>
            {parent.name}
          </Typography>
          <Box display="flex" flexWrap="wrap">
            {(parent.children || []).map((child) => (
              <FormControlLabel
                key={child.id}
                control={
                  <Checkbox
                    checked={value.includes(child.id)}
                    onChange={(event) =>
                      handleChange(child.id, event.target.checked)
                    }
                    color="primary"
                    size="small"
                  />
                }
                label={child.name}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default RiskOptionsSelector
